module.exports = __webpack_public_path__ + "rosacea_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/dermatologie/rosacea_4_after.jpg
// module id = 983
// module chunks = 0